import React, { Component } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { withTranslation } from "react-i18next";

class ReviewMarksToggle extends Component {
  render() {
    const {
      t,
      markId,
      markState,
      handleApprove,
      handleReject,
      canApproveMarks,
    } = this.props;
    const isRejected = markState === "Rejected";
    const isApproved = markState === "Approved";

    return (
      canApproveMarks && (
        <ButtonGroup
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="btn-group-toggle segmented-radio-group"
          data-toggle="buttons"
          aria-label="Basic example"
        >
          <button
            type="button"
            className={`btn btn-sm segmented-radio-button segmented-radio-button--danger${
              isRejected ? " is-active" : ""
            }`}
            onClick={() => handleReject([markId])}
            disabled={isRejected}
          >
            {isRejected ? t("Rejected") : t("Reject")}
          </button>
          <button
            type="button"
            className={`btn btn-sm segmented-radio-button segmented-radio-button--success${
              isApproved ? " is-active" : ""
            }`}
            onClick={() => handleApprove([markId])}
            disabled={isApproved}
          >
            {isApproved ? t("Approved") : t("Approve")}
          </button>
        </ButtonGroup>
      )
    );
  }
}

export default withTranslation(["marketdata"])(ReviewMarksToggle);
